import script from "./dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=7ee1bf88&lang=scss&scoped=true"
import "./dashboard.vue?vue&type=style&index=1&id=7ee1bf88&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee1bf88"]])

export default __exports__